module.exports = __webpack_public_path__ + "static/media/logo1.73f2b300.svg";